import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class TratamentoCustoMaoObraService {
    constructor(
        private apiService: ApiService
    ) {}

    post(form) : Observable<any> {
        return this.apiService.post('/custo-mao-obra', form)
    }
    
    getAll( idTratamento ): Observable<any> {
        let url : string = `/custo-mao-obra`
        return this.apiService.get(url, idTratamento)
    }

    get(id: string): Observable<any> {
        let url : string = `/custo-mao-obra/${id}`
        return this.apiService.get(url)
    }

    put(id: string, form) : Observable<any> {
        form._method = 'PUT'
        return this.apiService.post('/custo-mao-obra/'+id, form)
    }

    delete(id) {
        return this.apiService.delete('/custo-mao-obra/'+id)
    }

}